import {useState, useEffect} from "react";

import {DeviceType, useDeviceType} from "../hooks/useDeviceType.js";

function windowSize(height, width) {
  return {
    height: height,
    width: width,
  }
}

export function useAdaptiveMobileSize() {
  const prototypeMobileSize = windowSize(852, 393);
  const deviceType = useDeviceType();
  const [size, setSize] = useState(prototypeMobileSize);

  useEffect(() => {
    function resizeToMobileSize() {
      if (!window) {
        setSize(null);
        return;
      }
      let updatedSize;
      switch (deviceType) {
        case DeviceType.TABLET:
        case DeviceType.DESKTOP:
          const aspectRation = window.innerHeight / prototypeMobileSize.height;
          const height = Math.round(window.innerHeight);
          const width = Math.round(prototypeMobileSize.width * aspectRation);
          updatedSize = windowSize(height, width);
          setSize(updatedSize);
          break;
        case DeviceType.MOBILE:
          updatedSize = windowSize(window.innerHeight, window.innerWidth);
          setSize(updatedSize);
          break;
        default:
          setSize(null);
          break;
      }
    }
    resizeToMobileSize();
    window.addEventListener("resize", resizeToMobileSize);
    return () => {
      window.removeEventListener("resize", resizeToMobileSize);
    };
  }, []);
  return size;
}